'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getStagesSetCurrent = require('./getStagesSetCurrent');

var _getStagesSetCurrent2 = _interopRequireDefault(_getStagesSetCurrent);

var _setCurrentStage = require('./setCurrentStage');

var _setCurrentStage2 = _interopRequireDefault(_setCurrentStage);

var _paths = require('./paths');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (feis_id, stewarding_day) {
  var resetCurrentStage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState) {
    var currentStewardingDay = getState().getIn(['stages', 'ui', feis_id, 'currentStewardingDay']);
    var currentPageSource = getState().getIn(['stages', 'ui', feis_id, 'currentPageSource']);
    if (currentStewardingDay && currentPageSource === 'registration-history') {
      return Promise.resolve();
    }

    dispatch({
      feis_id: feis_id,
      stewarding_day: stewarding_day,
      type: 'SET_CURRENT_STEWARDING_DATE'
    });

    if (!resetCurrentStage) {
      return Promise.resolve();
    }

    var stages = (0, _paths.getStages)(getState(), feis_id);

    if (!stages) {
      return dispatch((0, _getStagesSetCurrent2.default)(feis_id));
    }

    var currentStage = getState().getIn(['stages', 'ui', 'stage']);

    if (currentStage === undefined) {
      var stagesForCurrentDay = stages.map(function (id) {
        return (0, _paths.getStage)(getState(), id);
      }).filter(function (stage) {
        return stage.get('dt') === stewarding_day;
      });

      stagesForCurrentDay.size > 0 && dispatch((0, _setCurrentStage2.default)(feis_id, stagesForCurrentDay.get(0).get('id')));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/stages/setCurrentStewardingDay.js
// module id = 248
// module chunks = 0